<template>
  <div class="newsall">
    <div
      class="newssingle"
      v-for="(i, j) in newslist"
      :key="j"
      @mouseenter="newshover(j)"
      @mouseleave="newshover(-1)"
      @click="checkinfo(i, j)"
      :style="{
        'margin-top': hoverindex == j ? '-0.52vw' : '0',
        'margin-bottom': hoverindex == j ? '1.56vw' : '1.04vw',
      }"
    >
      <img class="newsicon" :src="i.firstUrl" alt="" />
      <div class="newscon">
        <div class="newstitle">{{ i.title }}</div>
        <div class="newscontent">{{ i.summary }}</div>
      </div>
      <div class="newstime">
        <div class="mouth">{{ i.createTime.slice(5) }}</div>
        <div class="year">{{ i.createTime.slice(0, 4) }}</div>
        <div
          class="checkmore"
          @click="checkinfo(i, j)"
          style="display: flex; justify-content: center; align-items: center"
          v-if="hoverindex == j"
        >
          查看详情
        </div>
      </div>
    </div>
    <div class="pagination">
      <el-pagination
        background
        layout="prev, pager, next"
        :total="pagesize.total"
        :page-size="pagesize.size"
        @current-change="getlist"
        :current-page.sync="pagesize.page"
        prev-text="上一页"
        next-text="下一页"
      >
      </el-pagination>
    </div>
  </div>
</template>

<script>
export default {
  data() {
    return {
      newslist: [],
      hoverindex: -1,
      sendnews: {},
      pagesize: { page: 1, size: 10, total: 0 },
    };
  },
  methods: {
    checkinfo(e) {
      let data = {
        category: "人才发展/培训动态",
        id: e.id,
        current: 1,
        size: 999,
      };
      this.$router.push({
        path: "/news/info",
        query: data,
      });
    },
    async getlist() {
      try {
        let data = {
          category: "人才发展/培训动态",
          current: this.pagesize.page,
          size: this.pagesize.size,
        };
        const res = await this.$http.newslist(data);
        if (res.code == 200) {
          this.newslist = res.data; // 更新 list
        } else {
          // 处理错误情况
          console.log("Error fetching joinus list:", res.message);
        }
      } catch (error) {
        console.error("An error occurred while fetching the list:", error);
      }
    },
    newshover(e) {
      // for(){}
      this.hoverindex = e;
    },
    formattime() {
      for (let i in this.newslist) {
        this.newslist[i].year = this.newslist[i].time.slice(0, 4);
        this.newslist[i].mouth = this.newslist[i].time.slice(5, 10);
      }
    },
  },
  beforeMount() {
    this.formattime();
  },
  mounted() {
    this.getlist();
  },
};
</script>

<style scoped lang="less">
.newsall {
  .pagination {
    .active {
      background: rgba(25, 97, 172, 1) !important;
      border: 1px solid rgba(25, 97, 172, 1) !important;
    }
    .btn-prev,
    .btn-next {
      width: 95px;
    }
    .btn-prev,
    .btn-next,
    .number {
      background: #fff;
      border: 1px solid rgba(6, 25, 45, 0.26);
    }
    width: 100%;
    height: 2.08vw;
    text-align: center;
    margin-top: 2.6vw;
    color: rgba(6, 25, 45, 1);
  }
  .newssingle {
    .checkmore {
      width: 5.21vw;
      height: 2.08vw;
      display: flex !important;
      justify-content: center !important;
      align-items: center !important;
      border: 1px solid white;
      color: white;
      font-size: 0.94vw;
      cursor: pointer;
      background: rgba(22, 104, 188, 1);
      border-radius: 4px;
    }
    .newstime {
      .year {
        font-size: 0.94vw;
        color: rgba(18, 20, 58, 0.65);
      }
      .mouth {
        font-size: 1.46vw;
        color: rgba(18, 20, 58, 0.8);
        font-weight: 550;
      }
      flex: 1;
      height: 100%;
      border-left: 1px solid rgba(238, 241, 245, 1);
      display: flex;
      flex-direction: column;
      justify-content: center;
      align-items: center;
      gap: 0.94vw;
    }
    .newscon {
      .newscontent {
        width: 100%;
        height: 5vw;
        font-size: 0.83vw;
        line-height: 1.67vw;
        color: rgba(18, 20, 58, 0.65);
        display: -webkit-box;
        -webkit-box-orient: vertical;
        -webkit-line-clamp: 3; /* 显示的最大行数 */
        overflow: hidden;
      }
      .newstitle {
        font-size: 1.25vw;
        width: 100%;
        height: 1.61vw;
        margin-bottom: 1.25vw;
        font-weight: 600;
        color: rgba(6, 25, 45, 1);
        overflow: hidden;
        display: -webkit-box;
        -webkit-line-clamp: 1;
        -webkit-box-orient: vertical;
      }
      width: 35.1vw;
      height: 7.92vw;
      padding-right: 2.08vw;
    }
    .newsicon {
      width: 11.98vw;
      height: 7.92vw;
      margin-right: 1.25vw;
    }
    width: 100%;
    height: 10.42vw;
    background: #fff;
    box-shadow: 0px 3px 15px 0px rgba(68, 86, 103, 0.15);
    padding: 1.25vw;
    display: flex;
    position: relative;
    padding-right: 0;
    margin-bottom: 1.04vw;
  }
  width: 100%;
}
</style>
